var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElButton',{directives:[{name:"outFocus",rawName:"v-outFocus"}],attrs:{"type":"default","size":_vm.size},on:{"click":_vm.handleClick}},[_c('IconHc',{attrs:{"type":"qiehuan","size":"14px"}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }